// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Vuetify
import { createVuetify } from 'vuetify'

export default createVuetify({
  // https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
  // Vuetify 3 默认 light 主题的一些典型颜色配置：
  theme: {
    defaultTheme: 'myCustomTheme',
    themes: {
      myCustomTheme: {
        dark: false, 
        colors: {
          primary: '#1976D2',  // 主要颜色，默认为蓝色
          secondary: '#424242', // 次要颜色，默认为深灰色
          accent: '#FF4081',   // 强调颜色，默认为粉红色
          error: '#FF5252',    // 错误颜色，默认为红色
          info: '#2196F3',     // 信息颜色，默认为蓝色
          success: '#4CAF50',  // 成功颜色，默认为绿色
          warning: '#FFC107'   // 警告颜色，默认为黄色
        }
      }
    }
  }
})
